import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppService } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';

@Component({
  selector: 'app-modal-camera',
  templateUrl: './modal-camera.component.html',
  styleUrls: ['./modal-camera.component.scss'],
})
export class ModalCameraComponent implements OnInit {
  @ViewChild('modal', {static: true}) private _modal: any;
  _streamStatus;
  urlBase: string = null;
  urlCamera: string = null;
  urlCamera2: string = null;
  visible: number = null;

  constructor(
    private router: Router, 
    public route: ActivatedRoute,
    public _appService: AppService,
    public _gearAppService: GearAppService
  ) {
    this.route.params.subscribe((event) => {
      this.urlBase = atob(event.url);
      this.urlCamera = this.urlBase;
    });
  }
  
  ngOnInit() {
    setTimeout(() => { this._modal.open(); }, 50);
  }

  close() {
    this.urlCamera = '#';
    this.urlCamera2 = '#';
    clearInterval(this._streamStatus);
    setTimeout(() => this.router.navigate([{outlets: { modal: null}}]), 200);
  }

  onLoad(img) {
    if(img === this.visible) {
      return;
    }

    this.visible = img;

    if(img === 1) {
      this.urlCamera2 = '';
    } else {
      this.urlCamera = '';
    }

    this._streamStatus = setTimeout(() => {
      this.setImage(img);
    }, 30000);
  }

  setImage(img) {
    let url = this.urlBase + '?' + new Date().getTime();
  
    if(img === 1) {
      this.urlCamera2 = url;
    } else {
      this.urlCamera = url;
    }
  }

  onError(img, url) {
    if( ! url)
      return;

    let refresh = (img === 1) ? 2 : 1;
    
    this.setImage(refresh);
  }
}
